/** Mirrors the Credit API's ProtectionPlanCoverageEnum; joint prices at the co-applicant rate. */
export const EProtectionPlanCoverage = {
  None: 'none',
  Single: 'single',
  Joint: 'joint',
} as const

export type EProtectionPlanCoverage = (typeof EProtectionPlanCoverage)[keyof typeof EProtectionPlanCoverage]

export interface CalculatorEstimateRequestDto {
  merchantId: string
  /** The credit engine resolves the rate from this; the client never does. */
  ersScore: number
  provinceIso: string
  amountRequested: number
  /** Null on the first call; the backend falls back to the prequalified maximum. */
  term: number | null
  paymentPlanId: string
  paymentFrequency: string
  protectionPlan: EProtectionPlanCoverage
  deliveryOn: string
  firstPaymentOn: string
}

/** The merchant-facing slice: pricing only, no prequalification detail. */
export interface CalculatorEstimateResultDto {
  paymentForFrequency: number
  term: number
  interestRate: number
  effectiveRate: number
  totalInterestAmount: number
  lenderFeeRate: number
  lenderFee: number
  merchantFeeRate: number
  merchantFee: number
  protectionPlanAmount: number
}
